module.exports = __webpack_public_path__ + "static/img/junior-achievement.f669a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/junior-achievement.png
// module id = VYOV
// module chunks = 7